import {ReadService} from '@common/service/read.service';
import {ServerTranslateHttpLoader} from '@core/service/translation-loader';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class MissingTranslationHandlerImpl implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return `[${params.key}]`;
  }
}

export function HttpLoaderFactory(readService: ReadService) {
  // return new TranslateHttpLoader(http, './assets/lang/', '.json');
  return new ServerTranslateHttpLoader(readService);
}

// export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
//     return new TranslateHttpLoader(http, 'assets/lang/', `.json`);
// }

export function missingTranslationHandler(): MissingTranslationHandler {
  return new MissingTranslationHandlerImpl();
}
